import React, { useEffect } from "react";
import TextInput from "../../layout/TextInput.js";
import isEmailAddress from "../../utils/isEmailAddress.js";
import * as authService from "../../actions/auth.actions.js";
import { useApiResponse } from "../../context/ApiResponseContext.js";
import Alert from "../../layout/Alert.js";
import isInputEmpty from "../../utils/isInputEmpty.js";
import { useSearchParams } from "react-router-dom";
import {
  HOME_PAGE,
  SERVER_DOWN,
  TERMS_AND_CONDITIONS_PAGE,
} from "../../Constants.js";

function Register() {
  const [values, setValues] = React.useState({
    emailAddress: "",
    emailAddressErr: false,
    emailAddressErrText: "",

    password: "",
    passwordErr: false,
    passwordErrText: "",

    confirmPassword: "",
    confirmPasswordErr: false,
    confirmPasswordErrText: "",

    showPassword: false,
    callingRegisterApi: false,
  });

  const [apiResponse, setApiResponse] = useApiResponse();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const prefillEmail = searchParams.get("email");
    setValues((prevValues) => {
      return { ...prevValues, emailAddress: prefillEmail };
    });
  }, [searchParams]);

  const handleClickShowPassword = () => {
    setValues((prevValues) => {
      return { ...prevValues, showPassword: !values.showPassword };
    });
  };

  const inputHandler = (e) => {
    setValues((prevValues) => {
      return { ...prevValues, [e.target.id]: e.target.value };
    });
  };

  const resetInputValidationErrors = () => {
    setValues({
      ...values,
      emailAddressErr: false,
      emailAddressErrText: "",
      passwordErr: false,
      passwordErrText: "",
      confirmPasswordErr: false,
      confirmPasswordErrText: "",
    });
  };

  const isUserInputValid = () => {
    resetInputValidationErrors();
    const isInvalidEmail = !isEmailAddress(values.emailAddress);
    const isPasswordEmpty = isInputEmpty(values.password);
    const isConfirmPasswordMismatch =
      values.password.trim() !== values.confirmPassword.trim();

    setValues({
      ...values,
      emailAddressErr: isInvalidEmail,
      emailAddressErrText: isInvalidEmail
        ? "Email address format is incorrect"
        : "",
      passwordErr: isPasswordEmpty,
      passwordErrText: isPasswordEmpty ? "Password cannot be empty" : "",
      confirmPasswordErr: isConfirmPasswordMismatch,
      confirmPasswordErrText: isConfirmPasswordMismatch
        ? "Confirm password does not match"
        : "",
    });

    return !isInvalidEmail && !isPasswordEmpty && !isConfirmPasswordMismatch;
  };

  const submitHandler = (event) => {
    event.preventDefault();
    if (isUserInputValid()) {
      const registerUserObject = {
        email_address: values.emailAddress.trim(),
        password: values.password.trim(),
        confirmPassword: values.confirmPassword.trim(),
      };

      setValues((prevValues) => {
        return { ...prevValues, callingRegisterApi: true };
      });

      handleRegister(registerUserObject);
    }
  };

  const handleRegister = async (registerUserObject) => {
    const registerResponse = await authService.registerUser(registerUserObject);
    if (!registerResponse) {
      console.log(SERVER_DOWN);
      return;
    }
    setApiResponse(registerResponse.data);
    setValues((prevValues) => {
      return { ...prevValues, callingRegisterApi: false };
    });
    if (registerResponse.status === 200) {
      const loginUserObject = {
        email_address: values.emailAddress.trim(),
        password: values.password.trim(),
        keepMeLoggedIn: false,
      };
      const loginResponse = await authService.loginUser(loginUserObject);

      if (!loginResponse) {
        console.log(SERVER_DOWN);
        return;
      }

      if (loginResponse.status === 200) {
        window.location.href = HOME_PAGE;
      }
    }

    if (registerResponse.status === 500) {
      console.log(registerResponse);
    }
  };

  return (
    <div>
      <h1>Register</h1>
      {apiResponse.message && <Alert text={apiResponse.message} />}
      {apiResponse.password && (
        <Alert type="error" text={apiResponse.password} />
      )}
      {apiResponse.passwordConstraint && (
        <Alert type="error" text={apiResponse.passwordConstraint} />
      )}
      {apiResponse.passwordMatch && (
        <Alert type="error" text={apiResponse.passwordMatch} />
      )}
      {apiResponse.emailExists && (
        <Alert type="error" text={apiResponse.emailExists} />
      )}
      <form className="paddingtop20" action="#">
        <TextInput
          value={values.emailAddress}
          id="emailAddress"
          placeholder="E-mail address"
          isError={values.emailAddressErr}
          errorText={values.emailAddressErrText}
          onChange={inputHandler}
        />
        <div className="flexWrapper paddingtop20">
          <TextInput
            id="password"
            value={values.password}
            type={values.showPassword ? "text" : "password"}
            placeholder="Password"
            isError={values.passwordErr}
            errorText={values.passwordErrText}
            onChange={inputHandler}
          />
          <i
            onClick={handleClickShowPassword}
            class="paddingtop20 fa fa-pointer fa-eye"
          ></i>
          <TextInput
            id="confirmPassword"
            value={values.confirmPassword}
            type={values.showPassword ? "text" : "password"}
            placeholder="Confirm password"
            isError={values.confirmPasswordErr}
            errorText={values.confirmPasswordErrText}
            onChange={inputHandler}
          />
        </div>
        <div>
          <input
            disabled={values.callingRegisterApi}
            className="button"
            onClick={submitHandler}
            type="submit"
            value="Register"
          ></input>
        </div>
        <h6 className="font-weight-normal">
          <i>
            <p>By registering an account, you agree to</p> Head3d's{" "}
            <a
              href={TERMS_AND_CONDITIONS_PAGE}
              target="_blank"
              rel="noreferrer"
            >
              Terms of Service
            </a>
          </i>
        </h6>
      </form>
    </div>
  );
}
export default Register;
